import React from 'react';
import Loader from './Loader';

function LoadingItem() {
	return (
		<div className='flex items-center justify-center flex-1'>
			<div className='w-[200px] h-[200px] rounded-lg bg-white flex items-center justify-center'>
				<Loader size={40} color='gray' />
			</div>
		</div>
	);
}

export default LoadingItem;
